import React, { Component, Fragment } from 'react';
import {connect} from "react-redux";
import {IRootState} from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import {
    CommandBarButton, Dropdown, IDropdownOption, MessageBarType,
} from "office-ui-fabric-react";
import ApiService from "../ApiService";
import UserSelector from "../UserSelector";
import Actions from "../../redux/Actions";
import H from "history";
import {SchoolAccessLevel} from "../../models/SchoolAccessRecord";
import ListSchoolAccessRecordsPage from "./ListSchoolAccessRecordsPage";
import School from "../../models/School";
import { UserOption } from '../UserSelectorBase';
import LoadingPage from '../LoadingPage';
import SchoolMenu from '../SchoolMenu';
import SchoolPageTitle from '../SchoolPageTitle';

interface AddSchoolAccessRecordPageProps {
    tenantId: string;
    schoolCode: string;
       
    apiService: ApiService;
    history: H.History;
}

interface AddSchoolAccessRecordPageState {
    school?: School;
    selectedUsers: UserOption[];
    selectedLevel: SchoolAccessLevel;
}

class AddSchoolAccessRecordPage extends Component<AddSchoolAccessRecordPageProps & DispatchProps ,AddSchoolAccessRecordPageState> {
    static displayName = AddSchoolAccessRecordPage.name;
    
    private static accessLevelOptions : IDropdownOption[] = [
        {
            key: "manager",
            text: "School Manager",
        },
        {
            key: "leader",
            text: "School Leader"
        }
    ]

    constructor(props: AddSchoolAccessRecordPageProps & DispatchProps) {
        super(props);

        this.state = {
            selectedUsers: [],
            selectedLevel: "manager"
        }

    }

    public async componentDidMount(): Promise<void> {
        if(this.props.tenantId)
        {
            await this.load();
        }
    }

    protected submitForm = async () => {
        
        try
        {
            await Promise.all(this.state.selectedUsers.map((userOption) => {
                return this.props.apiService.createSchoolAccessRecord({
                    tenantId: this.props.tenantId,
                    schoolCode: this.props.schoolCode,
                    userOid: userOption.id,
                    level: this.state.selectedLevel
                });
            }));

            this.props.dispatch(Actions.showMessageBar("Saved successfully",MessageBarType.success));
            this.props.history.push(`/manage/${this.props.tenantId}/${this.props.schoolCode}/school-access`);
        }
        catch(e)
        {
            this.props.dispatch(Actions.showMessageBar("Failed to save access",MessageBarType.error));
        }

    };

    public async componentDidUpdate(prevProps: Readonly<AddSchoolAccessRecordPageProps & DispatchProps>, prevState: any): Promise<void> {
        if(this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode)
        {
            await this.load();
        }
    }

    private async load(): Promise<void> {
        var school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode)

        this.setState({
            school
        });   
    }

    private renderContent() {
        if (this.state.school === undefined) {
            return <LoadingPage />;
        }
        else {
            return <Fragment>
                {ListSchoolAccessRecordsPage.buildHelpBox()}
                <div className="card card">
                    <div className="card__header">
                        <span className={"card__title"}>Give users access</span>

                        <CommandBarButton
                            iconProps={{ iconName: "save" }}
                            text="Save"
                            onClick={this.submitForm}
                        />
                    </div>

                    <div className="card__content flex-column">
                        <Dropdown
                            label="Access Level"
                            selectedKey={this.state.selectedLevel}
                            onChange={(event: any, option?: IDropdownOption) => {
                                this.setState({
                                    selectedLevel: option!.key as SchoolAccessLevel
                                });
                            }}
                            placeholder="Select Access Level"
                            options={AddSchoolAccessRecordPage.accessLevelOptions}/>

                        <UserSelector
                            tenantId={this.props.tenantId}
                            className="card__input"
                            disabled={false}
                            multiSelect={true}
                            label={"Users"}
                            selectedUsers={this.state.selectedUsers}
                            onSelectionChanged={(selectedUsers: UserOption[]) => {
                                this.setState({
                                    selectedUsers
                                });
                            }} />
                    </div>
                </div>
            </Fragment>
        }
    }

    render() {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Access Management (Add)" reverse={true} />
                <SchoolMenu prefix="Access" prefixLink={`/manage/${this.props.tenantId}/${this.props.schoolCode}/school-access`} suffix="Add" />

                <div className={"cdb-admin-content cdb-admin-content--column"}>
                    {this.renderContent()}
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: { match: any, history: H.History }): AddSchoolAccessRecordPageProps => {
        return {
            apiService: state.auth.apiService,
            tenantId: ownProps.match.params.tenantId,
            schoolCode: ownProps.match.params.schoolCode,
            history: ownProps.history
        };
    }
)(AddSchoolAccessRecordPage)